/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host {
  display: inline-block;
}

.time-picker {
  display: flex;
  -webkit-user-select: none;
          user-select: none;
  align-items: center;
  background-color: var(--calcite-color-foreground-1);
  font-weight: var(--calcite-font-weight-medium);
  color: var(--calcite-color-text-1);
  --tw-shadow: 0 6px 20px -4px rgba(0, 0, 0, 0.1), 0 4px 12px -2px rgba(0, 0, 0, 0.08);
  --tw-shadow-colored: 0 6px 20px -4px var(--tw-shadow-color), 0 4px 12px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  border-radius: var(--calcite-border-radius);
}
.time-picker .column {
  display: flex;
  flex-direction: column;
}
.time-picker .meridiem--start {
  order: -1;
}
.time-picker .button {
  display: inline-flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  background-color: var(--calcite-color-foreground-1);
}
.time-picker .button:hover, .time-picker .button:focus {
  background-color: var(--calcite-color-foreground-2);
  outline: 2px solid transparent;
  outline-offset: 2px;
  z-index: var(--calcite-z-index-header);
  outline-offset: 0;
}
.time-picker .button:active {
  background-color: var(--calcite-color-foreground-3);
}
.time-picker .button.top-left {
  border-start-start-radius: var(--calcite-border-radius);
}
.time-picker .button.bottom-left {
  border-end-start-radius: var(--calcite-border-radius);
}
.time-picker .button.top-right {
  border-start-end-radius: var(--calcite-border-radius);
}
.time-picker .button.bottom-right {
  border-end-end-radius: var(--calcite-border-radius);
}
.time-picker .button calcite-icon {
  color: var(--calcite-color-text-3);
}
.time-picker .input {
  display: inline-flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  background-color: var(--calcite-color-foreground-1);
  font-weight: var(--calcite-font-weight-medium);
}
.time-picker .input:hover {
  box-shadow: inset 0 0 0 2px var(--calcite-color-foreground-2);
  z-index: var(--calcite-z-index-header);
}
.time-picker .input:focus, .time-picker .input:hover:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  outline-offset: 0;
}
.time-picker .input.inputFocus, .time-picker .input:hover.inputFocus {
  box-shadow: inset 0 0 0 2px var(--calcite-color-brand);
  z-index: var(--calcite-z-index-header);
}
.time-picker.scale-s {
  font-size: var(--calcite-font-size--1);
}
.time-picker.scale-s .button,
.time-picker.scale-s .input {
  padding-inline: 0.75rem;
  padding-block: 0.25rem;
}
.time-picker.scale-s:not(.show-meridiem) .delimiter:last-child {
  padding-inline-end: 0.75rem;
}
.time-picker.scale-m {
  font-size: var(--calcite-font-size-0);
}
.time-picker.scale-m .button,
.time-picker.scale-m .input {
  padding-inline: 1rem;
  padding-block: 0.5rem;
}
.time-picker.scale-m:not(.show-meridiem) .delimiter:last-child {
  padding-inline-end: 1rem;
}
.time-picker.scale-l {
  font-size: var(--calcite-font-size-1);
}
.time-picker.scale-l .button,
.time-picker.scale-l .input {
  padding-inline: 1.25rem;
  padding-block: 0.75rem;
}
.time-picker.scale-l:not(.show-meridiem) .delimiter:last-child {
  padding-inline-end: 1.25rem;
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}